import listSearch from './listSearch'

export default (query, name) => (dispatch, getState) => {
  dispatch({type:'change_sort', name})
}



/** WEBPACK FOOTER **
 ** ./app/actions/changeSort.js
 **/